import * as React from "react";
const SvgBlueCalendar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={36}
    fill="none"
    {...props}
  >
    <path
      fill="#466FF6"
      d="M28.5 7.5h-1.167V5.167c0-.644-.522-1.167-1.166-1.167H25c-.644 0-1.167.523-1.167 1.167V7.5H12.167V5.167C12.167 4.523 11.644 4 11 4H9.833c-.644 0-1.166.523-1.166 1.167V7.5H7.5C5.57 7.5 4 9.07 4 11v17.5C4 30.43 5.57 32 7.5 32h21c1.93 0 3.5-1.57 3.5-3.5V11c0-1.93-1.57-3.5-3.5-3.5m1.167 21c0 .643-.524 1.167-1.167 1.167h-21A1.17 1.17 0 0 1 6.333 28.5V15.713h23.334z"
    />
  </svg>
);
export default SvgBlueCalendar;
